export const fmt = (n: number | bigint): string =>
  new Intl.NumberFormat('en-US').format(n);

export const compact = (n: number): string => {
  if (n < 1_000) return String(n);
  if (n < 1_000_000) return `${Math.round(n / 100) / 10}K`.replace('.0K', 'K');
  return `${Math.round(n / 100_000) / 10}M`.replace('.0M', 'M');
};

export const fmtDateTime = (unixSeconds: number): string => {
  const d = new Date(unixSeconds * 1000);
  return d.toLocaleString(undefined, {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

export const fmtTime = (unixSeconds: number): string =>
  new Date(unixSeconds * 1000).toLocaleTimeString(undefined, {
    hour: '2-digit', minute: '2-digit',
  });

export const dayBucket = (unixSeconds: number): 'today' | 'yesterday' | string => {
  const now = new Date();
  const d = new Date(unixSeconds * 1000);
  const sameDay = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();
  if (sameDay(now, d)) return 'today';
  const y = new Date(now);
  y.setDate(now.getDate() - 1);
  if (sameDay(y, d)) return 'yesterday';
  return d.toLocaleDateString(undefined, { day: '2-digit', month: 'long', year: 'numeric' });
};

/** Average queue time: "<1m", "8m", "5h 8m", "7d 3h". */
export const queueTime = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  if (m < 1) return '<1m';
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return m % 60 ? `${h}h ${m % 60}m` : `${h}h`;
  const d = Math.floor(h / 24);
  return h % 24 ? `${d}d ${h % 24}h` : `${d}d`;
};

export const fillWindow = (fillSeconds: number): string => {
  const hours = Math.max(1, Math.round(fillSeconds / 3600));
  return hours < 24 ? `${hours}hr` : `${Math.round(hours / 24)}d`;
};
